<!-- source: loading.io -->
<!-- <div class="lds-ring">
	<div></div>
	<div></div>
	<div></div>
	<div></div>
</div> -->
<div *ngIf="this.loader.getLoading()" class="cssload-container">
    <div class="cssload-speeding-wheel"></div>
</div>